// import { initiateSocialLogin } from "./auth-api";

// const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
// const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
// const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
// const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI;

// const STATE_KEY = "oauth_state";
// const PROVIDER_KEY = "oauth_provider";

// export function redirectUriFor(provider) {
//   return provider === "google" ? GOOGLE_REDIRECT_URI : APPLE_REDIRECT_URI;
// }

// export async function startSocialLogin(provider) {
//   const redirectUri = redirectUriFor(provider);
//   const { state, code_challenge } = await initiateSocialLogin(
//     provider,
//     redirectUri,
//   );

//   sessionStorage.setItem(STATE_KEY, state);
//   sessionStorage.setItem(PROVIDER_KEY, provider);

//   const url =
//     provider === "google"
//       ? buildGoogleAuthUrl(state, code_challenge, redirectUri)
//       : buildAppleAuthUrl(state, redirectUri);

//   window.location.href = url;
// }

// function buildGoogleAuthUrl(state, codeChallenge, redirectUri) {
//   const params = new URLSearchParams({
//     client_id: GOOGLE_CLIENT_ID,
//     redirect_uri: redirectUri,
//     response_type: "code",
//     scope: "openid email profile",
//     state,
//     code_challenge: codeChallenge,
//     code_challenge_method: "S256",
//     access_type: "offline",
//     prompt: "consent",
//   });
//   return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
// }

// function buildAppleAuthUrl(state, redirectUri) {
//   const params = new URLSearchParams({
//     client_id: APPLE_CLIENT_ID,
//     redirect_uri: redirectUri,
//     response_type: "code",
//     scope: "name email",
//     response_mode: "form_post",
//     state,
//   });
//   return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
// }

// export function consumePendingOauthState() {
//   const state = sessionStorage.getItem(STATE_KEY);
//   const provider = sessionStorage.getItem(PROVIDER_KEY);
//   sessionStorage.removeItem(STATE_KEY);
//   sessionStorage.removeItem(PROVIDER_KEY);
//   if (!state || !provider) return null;
//   return { state, provider };
// }

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI;

const STATE_KEY = "oauth_state";
const PROVIDER_KEY = "oauth_provider";
const VERIFIER_KEY = "oauth_code_verifier";

export function redirectUriFor(provider) {
  return provider === "google" ? GOOGLE_REDIRECT_URI : APPLE_REDIRECT_URI;
}

// --- PKCE helpers (pure browser crypto, no backend needed) ---

function base64UrlEncode(bytes) {
  let str = "";
  for (const b of bytes) str += String.fromCharCode(b);
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function generateRandomString(length = 64) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

async function generateCodeChallenge(verifier) {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64UrlEncode(new Uint8Array(digest));
}

// --- Public API ---

export async function startSocialLogin(provider) {
  const redirectUri = redirectUriFor(provider);

  // Generate state + PKCE pair locally — no backend call, so no rate limit hit here.
  const state = generateRandomString(32);
  sessionStorage.setItem(STATE_KEY, state);
  sessionStorage.setItem(PROVIDER_KEY, provider);

  let url;
  if (provider === "google") {
    const codeVerifier = generateRandomString(64);
    const codeChallenge = await generateCodeChallenge(codeVerifier);
    sessionStorage.setItem(VERIFIER_KEY, codeVerifier);
    url = buildGoogleAuthUrl(state, codeChallenge, redirectUri);
  } else {
    url = buildAppleAuthUrl(state, redirectUri);
  }

  window.location.href = url;
}

function buildGoogleAuthUrl(state, codeChallenge, redirectUri) {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state,
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
    access_type: "offline",
    prompt: "consent",
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}

function buildAppleAuthUrl(state, redirectUri) {
  const params = new URLSearchParams({
    client_id: APPLE_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "name email",
    response_mode: "form_post",
    state,
  });
  return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
}

// Called on the /auth/callback/:provider page after Google/Apple redirects back.
// Returns everything your backend needs to complete the token exchange.
export function consumePendingOauthState() {
  const state = sessionStorage.getItem(STATE_KEY);
  const provider = sessionStorage.getItem(PROVIDER_KEY);
  const codeVerifier = sessionStorage.getItem(VERIFIER_KEY);

  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(PROVIDER_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);

  if (!state || !provider) return null;
  return { state, provider, codeVerifier };
}
